import React, { useState } from "react";
import {
  SealRegistrationFormData,
  getRegistrationCategory,
  getSelectedRoles,
  getSelectedIntendedUses,
} from "../SealRegistrationContext";

interface SealRegistrationSummaryCardProps {
  formData: SealRegistrationFormData;
}

export const SealRegistrationSummaryCard: React.FC<
  SealRegistrationSummaryCardProps
> = ({ formData }) => {
  const [showVineyards, setShowVineyards] = useState(false);
  const filledVineyards = formData.vineyardUrls.filter(
    (v) => v.value.trim() !== ""
  );

  return (
    <div className="seal-summary-card">
      <SummaryRow label="Name being registered" value={formData.registeredName} />
      <SummaryRow
        label="Registration category"
        value={getRegistrationCategory(formData.roles)}
      />
      <SummaryRow label="Legal organization" value={formData.legalOrganizationName} />
      <SummaryRow label="Applicant" value={formData.fullName} />
      <SummaryRow label="Applicant email" value={formData.email} />
      <SummaryRow
        label="Selected role(s)"
        value={getSelectedRoles(formData.roles).join(", ")}
      />
      <SummaryRow
        label="Intended seal use"
        value={getSelectedIntendedUses(formData.intendedUse).join(", ")}
      />
      <SummaryRow
        label="OVR vineyard records submitted"
        value={String(filledVineyards.length)}
      />
      <div className="form-fields-sub-text">
        <span
          className="form-fields-sub-text-link"
          onClick={() => setShowVineyards(!showVineyards)}
        >
          {showVineyards ? "Hide vineyard URLs" : "Show vineyard URLs"}
        </span>
        {showVineyards && (
          <ul>
            {filledVineyards.map((v, i) => (
              <li key={i}>{v.value}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

const SummaryRow: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <div className="seal-summary-row">
    <span className="seal-summary-row-label">{label}</span>
    <span className="seal-summary-row-value">{value}</span>
  </div>
);
